import axios from "axios"

export type OSMPlace = {
  place_id: number,
  display_name: string,
  addresstype: string,
  lat: number,
  lon: number,
  osm_type: string,
  osm_id: number,
}

export function useGeocoder() {
  async function search(query: string): Promise<OSMPlace[]> {
    const response = await axios.get(`/api/osm/search?q=${query}`)
    return response.data as OSMPlace[]
  }
  return {
    search,
  }
}
